import NavigationArea from '@components/Areas/NavigationArea';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { TNavigationAreaPath } from '@components/Areas/NavigationArea/NavigationArea';
import { useDocumentTitle } from '@hooks';

type AreaPageProps = {
    title: string,
    navigationPaths: TNavigationAreaPath[],
    home: string
}

const AreaPage: React.FC<AreaPageProps> = ({ title, navigationPaths, home }) => {

    useDocumentTitle(title, title)

    return <>
        <div className='tw-container tw-mx-auto'>
            <h1 className='title tw-mb-4'>{title}</h1>
        </div>
        <NavigationArea home={home} paths={navigationPaths} />
        <div className='tw-container tw-mx-auto tw-mt-4'>
            {/* Outlet Renders the child route's element, if there is one. (in App.tsx) */}
            <Outlet />
        </div>
    </>
}

export default AreaPage